import { createContext } from "react";
import { ClientObject, ReferantObject } from "../../types/models";

export const ClientContext = createContext({
  client: ClientObject,
  referant: ReferantObject,
  refreshClient:()=>{}
});
